import { x } from '@xstyled/styled-components';
import React from 'react';
import { MediaPlayerProvider } from '~/ui/video-player/MediaPlayerProvider';
import { AUDIO_POPUP } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { PopupButton } from './components/PopupButton';

interface Props {
  mediaUrl?: string;
  subtitlesUrl?: string;
  autoPlay?: boolean;
  name?: string;
  body?: string;
  empty?: boolean;
  top?: number;
  left?: number;
  pixelCoordinates?: string;
  shouldShow?: boolean;
  title?: number | string;

  /**
   * When true, the popup will prevent the next button from showing until the popup's
   * audio has been played. If there is no audio, opening the popup will unblock.
   */
  blocking?: boolean;
  replay?: boolean;
  isPopupCentered?: boolean;
  btnSize?: number;
  scroll?: boolean;
  parentId?: string;
  editable?: boolean;
  generated?: boolean;
}

export type AudioPopupDefinition = ItemDefinition<typeof AUDIO_POPUP, Props>;

export class AudioPopup extends Item<typeof AUDIO_POPUP, Props> {
  protected render({
    mediaUrl,
    id,
    name,
    top,
    empty,
    left,
    shouldShow = true,
    blocking = false,
    subtitlesUrl,
    body,
    title,
    replay = false,
    isPopupCentered = false,
    btnSize,
    scroll = false,
    parentId,
    editable = true,
    generated = false
  }: RenderProps<Props>) {
    const popupContent = (
      <MediaPlayerProvider>
        <PopupButton
          mediaUrl={mediaUrl}
          subtitlesUrl={subtitlesUrl}
          id={id}
          shouldShow={shouldShow}
          name={name || ''}
          body={body || ''}
          blocking={blocking}
          replay={replay}
          title={title}
          isPopupCentered={isPopupCentered}
          btnSize={btnSize}
          scroll={scroll}
          parentId={parentId}
          editable={editable}
          generated={generated}
        />
      </MediaPlayerProvider>
    );

    return top && left ? (
      <x.div position="absolute" top={`${top}%`} left={`${left}%`}>
        {popupContent}
      </x.div>
    ) : (
      popupContent
    );
  }
}

registry[AUDIO_POPUP] = AudioPopup;
